;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { z } from "zod/v4";
import { createWorkspaceSchema } from "@/lib/schema/workspace";
import { logger } from "@/lib/services/logger";
import { queryFetcher } from "@/queries/config/query-fetcher";
import type { Workspace } from "@/types/workspace";

export interface WorkspacesResponse {
	workspaces: Workspace[];
}

export interface CreateWorkspaceResponse {
	workspace: Workspace;
}

export interface TeamMember {
	email: string;
	role: string;
	permissions: {
		[key: string]: {
			view?: boolean;
			create?: boolean;
			edit?: boolean;
			delete?: boolean;
		};
	};
}

// export type CreateWorkspaceData = {
// 	name: string;
// 	organizationId: string;
// 	userId: string;
// 	views: Record<string, unknown>;
// 	teamMembers?: TeamMember[];
// }

export type CreateWorkspaceData = z.infer<typeof createWorkspaceSchema>;

/**
 * Creates a new workspace
 * @param workspace - The workspace data
 * @returns The created workspace
 */
export async function createWorkspace(
	workspace: CreateWorkspaceData,
): Promise<CreateWorkspaceResponse> {
	// Lets validate the workspace data
	const validationResult = createWorkspaceSchema.safeParse(workspace);

	if (!validationResult.success) {
		logger.error("Error creating workspace", validationResult.error, {
			workspace,
		});
		throw new Error("Error creating workspace");
	}

	return queryFetcher("/api/workspaces", {
		body: JSON.stringify(validationResult.data),
		method: "POST",
	});
}
